export const translations = {
  en: {
    nav: {
      home: "Home",
      about: "About Us",
      products: "Products",
      quality: "Quality",
      partners: "Why Shadong Prit",
      contact: "Contact",
      langLabel: "CN"
    },
    hero: {
      tagline: "Science-Backed Nutrition for Healthier Livestock",
      subtitle: "Global manufacturer of veterinary feed additives, APIs, and coccidiostats. ISO & GMP certified since 2018.",
      cta: "View Product Catalogue",
      ctaSecondary: "Contact Us"
    },
    about: {
      sectionLabel: "About Shandong Prit",
      title: "Engineering Solutions, Not Just Additives",
      description: "Established in 2018, Shandong Prit Biotechnology is a premier global manufacturer dedicated to the intersection of science and animal health. We don't just supply additives; we engineer solutions that improve feed efficiency, protect livestock, and drive sustainable growth for farmers worldwide.",
      description2: "With ISO and GMP-certified manufacturing facilities, we combine advanced technology, rigorous quality control systems, and international trade expertise to serve customers across global markets.",
      philosophy: "Our Philosophy",
      philosophyItems: [
        "Science-Driven Solutions",
        "Consistent Quality",
        "Long-Term Partnership"
      ],
      stats: [
        { value: "2018", label: "Established" },
        { value: "50+", label: "Countries Served" },
        { value: "6", label: "Product Categories" },
        { value: "100%", label: "Batch Traceability" }
      ]
    },
    products: {
      sectionLabel: "Product Catalogue",
      title: "Our Product Range",
      subtitle: "Comprehensive portfolio of veterinary feed additives and pharmaceutical ingredients",
      viewTable: "Table View",
      viewList: "List View",
      viewGrid: "Card View",
      specification: "Specification",
      category: "Category",
      product: "Product",
      categories: {
        antibiotic: "Antibiotic Series",
        coccidiostat: "Coccidiostat Series",
        api: "Veterinary APIs",
        binder: "Pellet Binder",
        otherPremix: "Other Premix",
        phosphates: "Phosphates"
      },
      categoryDescriptions: {
        antibiotic: "Carefully manufactured to improve feed conversion ratios and support healthy growth performance under controlled standards.",
        coccidiostat: "Formulated to effectively prevent and control coccidiosis in poultry and livestock, ensuring optimal health and productivity.",
        api: "High-purity veterinary APIs produced under GMP compliance to ensure safety, stability, and consistent efficacy.",
        binder: "Advanced binding solutions designed to improve pellet durability, reduce feed wastage, and enhance feed quality.",
        otherPremix: "Specialty mineral and nutritional premixes for balanced trace elements, immunity support, and feed quality in poultry and livestock.",
        phosphates: "Feed-grade dicalcium phosphate supplied as granular and powder for mineral supplementation in animal feed."
      }
    },
    quality: {
      sectionLabel: "Quality Assurance",
      title: "Uncompromising Quality Control",
      subtitle: "Your reputation is built on your feed. Ours is built on your results.",
      description: "Our ISO and GMP-certified facilities operate under a Zero-Error mindset. Every batch is a promise of safety and efficacy.",
      items: [
        { title: "Controlled Sourcing", desc: "Only the finest raw materials enter our production line." },
        { title: "Batch Traceability", desc: "Full transparency from our lab to your farm." },
        { title: "Advanced Formulation", desc: "Leveraging the latest technology for maximum stability." },
        { title: "Global Compliance", desc: "Meeting the rigorous standards of international trade." }
      ]
    },
    partners: {
      sectionLabel: "Why Shadong Prit",
      title: "Why Global Leaders Partner With Shadong Prit",
      items: [
        { title: "Certified Excellence", desc: "Fully ISO & GMP compliant manufacturing facilities." },
        { title: "Technical Edge", desc: "R&D team focused on stability and performance optimization." },
        { title: "Global Logistics", desc: "Expert documentation and seamless international delivery." },
        { title: "Strategic Value", desc: "Competitive pricing without sacrificing batch consistency." }
      ]
    },
    vision: {
      mission: "Mission",
      missionText: "To deliver scientifically developed nutrition that strengthens the global agricultural industry.",
      vision: "Vision",
      visionText: "To be the world's most respected manufacturer of veterinary solutions through integrity and innovation."
    },
    contact: {
      sectionLabel: "Start a Conversation",
      title: "Let's Work Together",
      subtitle: "Whether you need a new supplier or a long-term partner, we're here. Tell us about your needs and we'll get back to you.",
      email: "Email",
      address: "Address",
      phone: "Phone",
      addressValue: "302, No.1, Xingfu Street, No. 49, Xinhua Road, Linzi District, Zibo, Shandong, China",
      emailValue: "info@pritbiotech.com",
      phoneValue: "+86 150 9236 0555",
      formName: "Your Name",
      formSubject: "Subject",
      formEmail: "Your Email",
      formMessage: "Your Message",
      sendButton: "Compose Email",
      openGmail: "Open in Gmail",
      openDefault: "Open in default email"
    },
    footer: {
      tagline: "Science-Backed Nutrition. Global-Scale Performance.",
      copyright: "Shandong Prit Biotechnology Co., Ltd. All rights reserved.",
      address: "Address",
      email: "Email"
    },
    seo: {
      title: "Shandong Prit Biotechnology | Veterinary Feed Additives & APIs",
      description: "Global manufacturer of veterinary feed additives, APIs, and coccidiostats. ISO & GMP certified since 2018. Serving 50+ countries."
    }
  },
  zh: {
    nav: {
      home: "首页",
      about: "关于我们",
      products: "产品中心",
      quality: "质量保证",
      partners: "选择山东普瑞特",
      contact: "联系我们",
      langLabel: "EN"
    },
    hero: {
      tagline: "科学营养，守护畜禽健康",
      subtitle: "全球兽用饲料添加剂、原料药和球虫抑制剂制造商。自2018年起通过ISO和GMP认证。",
      cta: "查看产品目录",
      ctaSecondary: "联系我们"
    },
    about: {
      sectionLabel: "关于山东普瑞特",
      title: "不仅是添加剂，更是解决方案",
      description: "山东普瑞特生物科技有限公司成立于2018年，是一家致力于科学与动物健康交叉领域的全球领先制造商。我们不仅提供添加剂，更为全球农户提供改善饲料效率、保护畜禽健康、推动可持续增长的工程化解决方案。",
      description2: "凭借ISO和GMP认证的生产设施，我们将先进技术、严格的质量控制体系和国际贸易专业知识相结合，服务于全球各地的客户。",
      philosophy: "我们的理念",
      philosophyItems: [
        "科学驱动的解决方案",
        "始终如一的品质",
        "长期合作伙伴关系"
      ],
      stats: [
        { value: "2018", label: "成立年份" },
        { value: "50+", label: "服务国家" },
        { value: "6", label: "产品类别" },
        { value: "100%", label: "批次可追溯" }
      ]
    },
    products: {
      sectionLabel: "产品目录",
      title: "产品系列",
      subtitle: "兽用饲料添加剂和医药原料的全面产品组合",
      viewTable: "表格视图",
      viewList: "列表视图",
      viewGrid: "卡片视图",
      specification: "规格",
      category: "类别",
      product: "产品",
      categories: {
        antibiotic: "抗生素系列",
        coccidiostat: "球虫抑制剂系列",
        api: "兽药原料药",
        binder: "颗粒粘合剂",
        otherPremix: "其他预混料",
        phosphates: "磷酸盐"
      },
      categoryDescriptions: {
        antibiotic: "精心生产，改善饲料转化率，在受控标准下支持健康生长表现。",
        coccidiostat: "专业配方，有效预防和控制家禽和畜禽球虫病，确保最佳健康和生产力。",
        api: "在GMP合规条件下生产的高纯度兽药原料药，确保安全性、稳定性和一致的疗效。",
        binder: "先进的粘合解决方案，旨在提高颗粒耐久性，减少饲料浪费，提升饲料品质。",
        otherPremix: "矿物与营养类预混料，均衡微量元素，支持免疫与饲料品质，适用于家禽与畜禽。",
        phosphates: "饲料级磷酸氢钙，提供颗粒与粉末两种形态，用于动物饲料矿物补充。"
      }
    },
    quality: {
      sectionLabel: "质量保证",
      title: "不妥协的质量控制",
      subtitle: "您的声誉建立在您的饲料上，我们的声誉建立在您的成果上。",
      description: "我们的ISO和GMP认证设施在\u201C零差错\u201D理念下运营。每一批次都是安全与功效的承诺。",
      items: [
        { title: "可控采购", desc: "只有最优质的原材料才能进入我们的生产线。" },
        { title: "批次可追溯", desc: "从我们的实验室到您的农场，全程透明。" },
        { title: "先进配方", desc: "利用最新技术实现最大稳定性。" },
        { title: "全球合规", desc: "满足国际贸易的严格标准。" }
      ]
    },
    partners: {
      sectionLabel: "选择山东普瑞特",
      title: "全球领先企业选择山东普瑞特的理由",
      items: [
        { title: "认证卓越", desc: "完全符合ISO和GMP标准的生产设施。" },
        { title: "技术优势", desc: "研发团队专注于稳定性和性能优化。" },
        { title: "全球物流", desc: "专业文件处理和无缝国际配送。" },
        { title: "战略价值", desc: "在不牺牲批次一致性的前提下提供有竞争力的价格。" }
      ]
    },
    vision: {
      mission: "使命",
      missionText: "提供科学开发的营养方案，增强全球农业产业实力。",
      vision: "愿景",
      visionText: "通过诚信与创新，成为全球最受尊敬的兽药解决方案制造商。"
    },
    contact: {
      sectionLabel: "开始对话",
      title: "携手合作",
      subtitle: "无论您需要新供应商还是长期合作伙伴，我们随时为您服务。告诉我们您的需求，我们会尽快回复。",
      email: "电子邮箱",
      address: "地址",
      phone: "电话",
      addressValue: "中国山东省淄博市临淄区新华路49号幸福街1号302室",
      emailValue: "info@pritbiotech.com",
      phoneValue: "+86 150 9236 0555",
      formName: "您的姓名",
      formSubject: "主题",
      formEmail: "您的邮箱",
      formMessage: "您的留言",
      sendButton: "撰写邮件",
      openGmail: "在 Gmail 中打开",
      openDefault: "使用默认邮箱打开"
    },
    footer: {
      tagline: "科学营养，全球品质。",
      copyright: "山东普瑞特生物科技有限公司 版权所有。",
      address: "地址",
      email: "邮箱"
    },
    seo: {
      title: "山东普瑞特生物科技 | 兽用饲料添加剂与原料药",
      description: "全球兽用饲料添加剂、原料药和球虫抑制剂制造商。自2018年起通过ISO和GMP认证。服务50多个国家。"
    }
  }
};
